<template>
    <div class="evaluation-table">

        <!-- END: Subheader -->
        <div class="m-content">

            <!--begin::Portlet-->
            <div class="m-portlet">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                Filter
                            </h3>
                        </div>
                    </div>
                </div>

                <!--begin::Form-->
                <form class="m-form m-form--fit m-form--label-align-right">
                    <div class="m-portlet__body">
                        <div class="row form-group m-form__group ">
                            <div class="col-6">
                                <button @click="defaultDates = 1" type="button" class="btn btn-sm m-btn m-btn--custom" :class="defaultDates == 1 ? 'btn-primary' : 'btn-default'">letzte Woche</button>
                                <button @click="defaultDates = 2" type="button" class="btn btn-sm m-btn m-btn--custom" :class="defaultDates == 2 ? 'btn-primary' : 'btn-default'">diese Woche</button>
                                <button @click="defaultDates = 3" type="button" class="btn btn-sm m-btn m-btn--custom" :class="defaultDates == 3 ? 'btn-primary' : 'btn-default'">letzter Monat</button>
                                <button @click="defaultDates = 4" type="button" class="btn btn-sm m-btn m-btn--custom" :class="defaultDates == 4 ? 'btn-primary' : 'btn-default'">dieser Monat</button>
                                <button @click="defaultDates = 5" type="button" class="btn btn-sm m-btn m-btn--custom" :class="defaultDates == 5 ? 'btn-primary' : 'btn-default'">letztes Jahr</button>
                                <button @click="defaultDates = 6" type="button" class="btn btn-sm m-btn m-btn--custom" :class="defaultDates == 6 ? 'btn-primary' : 'btn-default'">dieses Jahr</button>
                            </div>
                        </div>
                    </div>
                </form>

                <!--end::Form-->
            </div>

            <!--end::Portlet-->

        </div>

        <!-- END: Subheader -->
        <div class="m-content">
            <div class="row m-row--col-separator-xl">
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Anfragen Herkunft
                                    </h3>
                                    <span class="m-widget14__desc">

									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_inquiry_inquiry_refferer" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#4285F4 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">Adwords: <span v-html="statistikData.inquiryArr.refferer.adwords"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#008373 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">Bing: <span v-html="statistikData.inquiryArr.refferer.bing"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#4267B2 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">Facebook: <span v-html="statistikData.inquiryArr.refferer.facebook"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#F4B400 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">Google COM: <span v-html="statistikData.inquiryArr.refferer.googleCOM"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#F4B400 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">Google DE: <span v-html="statistikData.inquiryArr.refferer.googleDE"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#F4B400 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">Google AT: <span v-html="statistikData.inquiryArr.refferer.googleAT"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#F4B400 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">Google CH: <span v-html="statistikData.inquiryArr.refferer.googleCH"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#AAAAAA !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">Yahoo: <span v-html="statistikData.inquiryArr.refferer.yahoo"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#DDDDDD !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">ecosia: <span v-html="statistikData.inquiryArr.refferer.ecosia"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#000000 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">Keine Angabe: <span v-html="statistikData.inquiryArr.refferer.emptyString"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text">Sonstiges: <span v-html="statistikData.inquiryArr.refferer.sonstiges"></span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Projekte abgeschlossen Herkunft
                                    </h3>
                                    <span class="m-widget14__desc">

									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_inquiry_project_refferer" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[1].count"></span>x Preis zu hoch: <span v-html="statistikData.inquiryNegativeArr.reasons[1].sumOutput"></span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Anfragen nach Kundenklassen (<span v-if="statistikData.inquiryArr" v-html="statistikData.inquiryArr.sumOutput"></span>)
                                    </h3>
                                    <span class="m-widget14__desc">
                                        <span v-if="statistikData.inquiryArr" v-html="statistikData.inquiryArr.count"></span> Anfragen aufgeteilt in die verschiedenen Kundenklassen
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_inquiry_class_chart" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[1].count"></span>x A Kunde: <span v-html="statistikData.inquiryArr.classArr[1].sumOutput"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#87decd !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[2].count"></span>x B Kunde: <span v-html="statistikData.inquiryArr.classArr[2].sumOutput"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#c3efe6 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[3].count"></span>x C Kunde: <span v-html="statistikData.inquiryArr.classArr[3].sumOutput"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#777777 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[4].count"></span>x D Kunde: <span v-html="statistikData.inquiryArr.classArr[4].sumOutput"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#999999 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[5].count"></span>x E Kunde: <span v-html="statistikData.inquiryArr.classArr[5].sumOutput"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#BBBBBB !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[6].count"></span>x F Kunde: <span v-html="statistikData.inquiryArr.classArr[6].sumOutput"></span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Absagen für Anfragen
                                    </h3>
                                    <span class="m-widget14__desc">

									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_inquiry_absagen_chart" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[1].count"></span>x Preis zu hoch: <span v-html="statistikData.inquiryNegativeArr.reasons[1].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#87decd !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[2].count"></span>x Wir bieten den Service nicht an: <span v-html="statistikData.inquiryNegativeArr.reasons[2].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#c3efe6 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[3].count"></span>x Anderen Dienstleister gewählt: <span v-html="statistikData.inquiryNegativeArr.reasons[3].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#777777 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[4].count"></span>x Keine Rückmeldung: <span v-html="statistikData.inquiryNegativeArr.reasons[4].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#999999 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[5].count"></span>x Projekt abgesagt: <span v-html="statistikData.inquiryNegativeArr.reasons[5].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#BBBBBB !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[6].count"></span>x Arschlochkunde: <span v-html="statistikData.inquiryNegativeArr.reasons[6].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#000000 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[7].count"></span>x Sonstiges: <span v-html="statistikData.inquiryNegativeArr.reasons[7].sumOutput"></span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Timetracks ({{ statistikData.hoursTrackt }})
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_timetrack_chart" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#000000 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Franzi: <span v-html="statistikData.employeeArr[3].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Daniela: <span v-html="statistikData.employeeArr[659].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#666666 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Sarah: <span v-html="statistikData.employeeArr[341].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#36a3f7 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Steffen: <span v-html="statistikData.employeeArr[652].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#999999 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Lena: <span v-html="statistikData.employeeArr[529].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#716aca !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Lara: <span v-html="statistikData.employeeArr[637].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#716aca !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Jessy: <span v-html="statistikData.employeeArr[1525].hours"></span> HH:MM</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Umsatz Fotografen ()
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Zusammengefasst in Geld, von fotografierten Projekten in dem Zeitraum.
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_employee_chart" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#000000 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Franzi: <span v-html="statistikData.employeeArr[3].sumFormat"></span> (<span v-html="statistikData.employeeArr[3].count"></span> Projekte)</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Daniela: <span v-html="statistikData.employeeArr[659].sumFormat"></span> (<span v-html="statistikData.employeeArr[659].count"></span> Projekte)</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#666666 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Sarah: <span v-html="statistikData.employeeArr[341].sumFormat"></span> (<span v-html="statistikData.employeeArr[341].count"></span> Projekte)</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#36a3f7 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Steffen: <span v-html="statistikData.employeeArr[652].sumFormat"></span> (<span v-html="statistikData.employeeArr[652].count"></span> Projekte)</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#999999 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Lena: <span v-html="statistikData.employeeArr[529].sumFormat"></span> (<span v-html="statistikData.employeeArr[529].count"></span> Projekte)</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#716aca !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Lara: <span v-html="statistikData.employeeArr[637].sumFormat"></span> (<span v-html="statistikData.employeeArr[637].count"></span> Projekte)</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Arbeitsstunden <span v-if="statistikData.workload">(Auslastung: <span v-if="statistikData.workload < 70" class="m--font-danger">{{ statistikData.workload }}%</span><span v-else class="m--font-success">{{ statistikData.workload }}%</span>)</span>
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Wieviele Arbeitsstunden stehen zur Verfügung. Gerechnet wird mit 3,5 aktiven Arbeitern.
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <p>Auslastung</p>
                                        <div id="m_morris_2" style="height:275px;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Summen
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <p>Wieviele Projekte haben wir in diesem Monat bekommen</p>
                                        <div id="m_morris_1" style="height:275px;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Projekte nach Kategorie
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_category_chart" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 d-none" v-if="statistikData.doneArr">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">
                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Abgeschlossene Projekte -> Wann generiert?
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.
									</span>
                                </div>
                                <div class="row">
                                    <div class="col-5">
                                        <div class="row">
                                            <div class="col-6">0 Uhr - 6 Uhr</div>
                                            <div class="col-6">{{ statistikData.doneArr.time["0-6"].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.time["0-6"].count }} Stk.)</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">6 Uhr - 12 Uhr</div>
                                            <div class="col-6">{{ statistikData.doneArr.time["6-12"].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.time["6-12"].count }} Stk.)</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">12 Uhr - 18 Uhr</div>
                                            <div class="col-6">{{ statistikData.doneArr.time["12-18"].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.time["12-18"].count }} Stk.)</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">18 Uhr - 20 Uhr</div>
                                            <div class="col-6">{{ statistikData.doneArr.time["18-20"].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.time["18-20"].count }} Stk.)</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">20 Uhr - 24 Uhr</div>
                                            <div class="col-6">{{ statistikData.doneArr.time["20-0"].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.time["20-0"].count }} Stk.)</div>
                                        </div>
                                    </div>

                                    <div class="col-5 offset-2">
                                        <div v-if="statistikData.doneArr.day[1]" class="row">
                                            <div class="col-6">Montag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[1].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[1].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[2]" class="row">
                                            <div class="col-6">Dienstag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[2].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[2].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[3]" class="row">
                                            <div class="col-6">Mittwoch</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[3].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[3].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[4]" class="row">
                                            <div class="col-6">Donnerstag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[4].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[4].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[5]" class="row">
                                            <div class="col-6">Freitag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[5].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[5].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[6]" class="row">
                                            <div class="col-6">Samstag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[6].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[6].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[7]" class="row">
                                            <div class="col-6">Sonntag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[7].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[7].count }} Stk.)</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row m-row--col-separator-xl" v-if="statistikData.doneArr && statistikData.doneArr.projectArr">
                <project-stats class="col-xl-4" v-for="project in statistikData.doneArr.projectArr" :project="project" :key="project.id"></project-stats>
            </div>
        </div>
        <!-- END: Subheader -->

        <div class="m-content">
            <div class="row m-row--col-separator-xl">
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Neukunden / Stammkunden
                                    </h3>
                                    <span class="m-widget14__desc">

									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_inquiry_inquiry_neu-stamm" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#4285F4 !important;"></span>
                                                <span v-if="statistikData.saleArr" class="m-widget14__legend-text">Adwords: <span v-html="statistikData.inquiryArr.refferer.adwords"></span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Projekte abgeschlossen Herkunft
                                    </h3>
                                    <span class="m-widget14__desc">

									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_inquiry_project_refferer" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[1].count"></span>x Preis zu hoch: <span v-html="statistikData.inquiryNegativeArr.reasons[1].sumOutput"></span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Anfragen nach Kundenklassen (<span v-if="statistikData.inquiryArr" v-html="statistikData.inquiryArr.sumOutput"></span>)
                                    </h3>
                                    <span class="m-widget14__desc">
                                        <span v-if="statistikData.inquiryArr" v-html="statistikData.inquiryArr.count"></span> Anfragen aufgeteilt in die verschiedenen Kundenklassen
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_inquiry_class_chart" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[1].count"></span>x A Kunde: <span v-html="statistikData.inquiryArr.classArr[1].sumOutput"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#87decd !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[2].count"></span>x B Kunde: <span v-html="statistikData.inquiryArr.classArr[2].sumOutput"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#c3efe6 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[3].count"></span>x C Kunde: <span v-html="statistikData.inquiryArr.classArr[3].sumOutput"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#777777 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[4].count"></span>x D Kunde: <span v-html="statistikData.inquiryArr.classArr[4].sumOutput"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#999999 !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[5].count"></span>x E Kunde: <span v-html="statistikData.inquiryArr.classArr[5].sumOutput"></span></span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#BBBBBB !important;"></span>
                                                <span v-if="statistikData.inquiryArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryArr.classArr[6].count"></span>x F Kunde: <span v-html="statistikData.inquiryArr.classArr[6].sumOutput"></span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Absagen für Anfragen
                                    </h3>
                                    <span class="m-widget14__desc">

									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_inquiry_absagen_chart" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[1].count"></span>x Preis zu hoch: <span v-html="statistikData.inquiryNegativeArr.reasons[1].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#87decd !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[2].count"></span>x Wir bieten den Service nicht an: <span v-html="statistikData.inquiryNegativeArr.reasons[2].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#c3efe6 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[3].count"></span>x Anderen Dienstleister gewählt: <span v-html="statistikData.inquiryNegativeArr.reasons[3].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#777777 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[4].count"></span>x Keine Rückmeldung: <span v-html="statistikData.inquiryNegativeArr.reasons[4].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#999999 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[5].count"></span>x Projekt abgesagt: <span v-html="statistikData.inquiryNegativeArr.reasons[5].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#BBBBBB !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[6].count"></span>x Arschlochkunde: <span v-html="statistikData.inquiryNegativeArr.reasons[6].sumOutput"></span></span>
                                            </div>
                                        </div>
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#000000 !important;"></span>
                                                <span v-if="statistikData.inquiryNegativeArr" class="m-widget14__legend-text"><span v-html="statistikData.inquiryNegativeArr.reasons[7].count"></span>x Sonstiges: <span v-html="statistikData.inquiryNegativeArr.reasons[7].sumOutput"></span></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Timetracks ({{ statistikData.hoursTrackt }})
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_timetrack_chart" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#000000 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Franzi: <span v-html="statistikData.employeeArr[3].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Daniela: <span v-html="statistikData.employeeArr[659].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#666666 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Sarah: <span v-html="statistikData.employeeArr[341].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#36a3f7 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Steffen: <span v-html="statistikData.employeeArr[652].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#999999 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Lena: <span v-html="statistikData.employeeArr[529].hours"></span> HH:MM</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#716aca !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Lara: <span v-html="statistikData.employeeArr[637].hours"></span> HH:MM</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Umsatz Fotografen ()
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Zusammengefasst in Geld, von fotografierten Projekten in dem Zeitraum.
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_employee_chart" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#000000 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Franzi: <span v-html="statistikData.employeeArr[3].sumFormat"></span> (<span v-html="statistikData.employeeArr[3].count"></span> Projekte)</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#34bfa3 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Daniela: <span v-html="statistikData.employeeArr[659].sumFormat"></span> (<span v-html="statistikData.employeeArr[659].count"></span> Projekte)</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#666666 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Sarah: <span v-html="statistikData.employeeArr[341].sumFormat"></span> (<span v-html="statistikData.employeeArr[341].count"></span> Projekte)</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#36a3f7 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Steffen: <span v-html="statistikData.employeeArr[652].sumFormat"></span> (<span v-html="statistikData.employeeArr[652].count"></span> Projekte)</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#999999 !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Lena: <span v-html="statistikData.employeeArr[529].sumFormat"></span> (<span v-html="statistikData.employeeArr[529].count"></span> Projekte)</span>
                                            </div>
                                            <div class="m-widget14__legend">
                                                <span class="m-widget14__legend-bullet m--bg-accent" style="background-color:#716aca !important;"></span>
                                                <span v-if="statistikData.employeeArr" class="m-widget14__legend-text">Lara: <span v-html="statistikData.employeeArr[637].sumFormat"></span> (<span v-html="statistikData.employeeArr[637].count"></span> Projekte)</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Arbeitsstunden <span v-if="statistikData.workload">(Auslastung: <span v-if="statistikData.workload < 70" class="m--font-danger">{{ statistikData.workload }}%</span><span v-else class="m--font-success">{{ statistikData.workload }}%</span>)</span>
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Wieviele Arbeitsstunden stehen zur Verfügung. Gerechnet wird mit 3,5 aktiven Arbeitern.
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <p>Auslastung</p>
                                        <div id="m_morris_2" style="height:275px;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Summen
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <p>Wieviele Projekte haben wir in diesem Monat bekommen</p>
                                        <div id="m_morris_1" style="height:275px;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">

                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Projekte nach Kategorie
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.
									</span>
                                </div>
                                <div class="row align-items-center">
                                    <div class="col">
                                        <div id="m_category_chart" class="m-widget14__chart1" style="height: 300px">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="m-widget14__legends">


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 d-none" v-if="statistikData.doneArr">
                    <div class="m-portlet">
                        <div class="m-portlet__body m-portlet__body--no-padding">
                            <div class="m-widget14">
                                <div class="m-widget14__header">
                                    <h3 class="m-widget14__title">
                                        Abgeschlossene Projekte -> Wann generiert?
                                    </h3>
                                    <span class="m-widget14__desc">
                                        Zusammengefasst in Stunden, es zählen nur abgeschlossene Timetracks.
									</span>
                                </div>
                                <div class="row">
                                    <div class="col-5">
                                        <div class="row">
                                            <div class="col-6">0 Uhr - 6 Uhr</div>
                                            <div class="col-6">{{ statistikData.doneArr.time["0-6"].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.time["0-6"].count }} Stk.)</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">6 Uhr - 12 Uhr</div>
                                            <div class="col-6">{{ statistikData.doneArr.time["6-12"].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.time["6-12"].count }} Stk.)</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">12 Uhr - 18 Uhr</div>
                                            <div class="col-6">{{ statistikData.doneArr.time["12-18"].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.time["12-18"].count }} Stk.)</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">18 Uhr - 20 Uhr</div>
                                            <div class="col-6">{{ statistikData.doneArr.time["18-20"].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.time["18-20"].count }} Stk.)</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">20 Uhr - 24 Uhr</div>
                                            <div class="col-6">{{ statistikData.doneArr.time["20-0"].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.time["20-0"].count }} Stk.)</div>
                                        </div>
                                    </div>

                                    <div class="col-5 offset-2">
                                        <div v-if="statistikData.doneArr.day[1]" class="row">
                                            <div class="col-6">Montag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[1].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[1].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[2]" class="row">
                                            <div class="col-6">Dienstag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[2].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[2].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[3]" class="row">
                                            <div class="col-6">Mittwoch</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[3].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[3].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[4]" class="row">
                                            <div class="col-6">Donnerstag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[4].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[4].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[5]" class="row">
                                            <div class="col-6">Freitag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[5].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[5].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[6]" class="row">
                                            <div class="col-6">Samstag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[6].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[6].count }} Stk.)</div>
                                        </div>
                                        <div v-if="statistikData.doneArr.day[7]" class="row">
                                            <div class="col-6">Sonntag</div>
                                            <div class="col-6">{{ statistikData.doneArr.day[7].sum.toFixed(2).replace('.', ',') }}€ ({{ statistikData.doneArr.day[7].count }} Stk.)</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row m-row--col-separator-xl" v-if="statistikData.doneArr && statistikData.doneArr.projectArr">
                <project-stats class="col-xl-4" v-for="project in statistikData.doneArr.projectArr" :project="project" :key="project.id"></project-stats>
            </div>
        </div>
    </div>
</template>
<script>

    import ProjectStats from "./ProjectStats";

    export default {
        name: 'inquiry-site',

        components: {

            ProjectStats,

        },
        data() {
            return {
                dateFrom: "",
                dateTo: "",
                defaultDates: 0,
                statistikData: []
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.defaultDates = 1;
            });
        },
        methods: {
            customDateFormat(date) {
                return moment(date).format('DD/MM/YY');
            },
            getEvaluationData(){
                let them = this;

                $.ajax({
                    url :'/get-ajax-evaluation-data',
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: { dateFrom: them.dateFrom, dateTo: them.dateTo },
                    success:  (data) => {
//console.log(data);
                        them.statistikData = JSON.parse(data);
                        them.initCharts();
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            },
            initCharts(){
                $("#m_inquiry_inquiry_refferer").empty();
                $("#m_inquiry_project_refferer").empty();
                $("#m_timetrack_chart").empty();
                $("#m_employee_chart").empty();
                $("#m_inquiry_inquiry_neu-stamm").empty();
                $("#m_category_chart").empty();
                $("#m_inquiry_class_chart").empty();
                $("#m_inquiry_absagen_chart").empty();
                $("#m_morris_1").empty();
                $("#m_morris_2").empty();

                Morris.Bar({
                    element: 'm_morris_1',
                    data: [
                        {
                            y: "Anfragen",
                            a: this.statistikData.inquiryArr.sum,
                        },
                        {
                            y: "Projekte bekommen",
                            a: this.statistikData.saleArr.sum,
                        },
                        {
                            y: "Projekte fotografiert",
                            a: this.statistikData.photoArr.sum,
                        },
                        {
                            y: "Projekte abgeschlossen",
                            a: this.statistikData.doneArr.sum,
                        },
                    ],
                    xkey: 'y',
                    ykeys: ['a'],
                    labels: ['Umsatz'],
                    barColors: ['#000']
                });

                Morris.Bar({
                    element: 'm_morris_2',
                    data: [
                        {
                            y: "Arbeitsstunden im Zeitraum",
                            a: this.statistikData.workingHours,
                        },
                        {
                            y: "Arbeitsstunden in der KW Planung",
                            a: this.statistikData.kwHours,
                        },
                        {
                            y: "Arbeitsstunden in der Zeit getrackt",
                            a: this.statistikData.hoursTrackt,
                        }
                    ],
                    xkey: 'y',
                    ykeys: ['a'],
                    labels: ['Stunden'],
                    barColors: ['#000']
                });

                Morris.Bar({
                    element: 'm_inquiry_inquiry_neu-stamm',
                    data: [
                        {
                            y: "1. Projekt",
                            a: this.statistikData.saleArr.projectCountArr["1"].sum,
                        },
                        {
                            y: "2. Projekt",
                            a: this.statistikData.saleArr.projectCountArr["2"].sum,
                        },
                        {
                            y: "3-5. Projekt",
                            a: this.statistikData.saleArr.projectCountArr["3-5"].sum,
                        },
                        {
                            y: "5-10. Projekt",
                            a: this.statistikData.saleArr.projectCountArr["5-10"].sum,
                        },
                        {
                            y: ">10. Projekt",
                            a: this.statistikData.saleArr.projectCountArr[">10"].sum,
                        },
                    ],
                    xkey: 'y',
                    ykeys: ['a'],
                    labels: ['Stunden'],
                    barColors: ['#000']
                });

                Morris.Donut({
                    element: 'm_inquiry_inquiry_refferer',
                    data: [
                        {
                            label: "Adwords",
                            value: this.statistikData.inquiryArr.refferer.adwords
                        },
                        {
                            label: "Bing",
                            value: this.statistikData.inquiryArr.refferer.bing
                        },
                        {
                            label: "Facebook",
                            value: this.statistikData.inquiryArr.refferer.facebook
                        },
                        {
                            label: "Google COM",
                            value: this.statistikData.inquiryArr.refferer.googleCOM
                        },
                        {
                            label: "Google DE",
                            value: this.statistikData.inquiryArr.refferer.googleDE
                        },
                        {
                            label: "Google AT",
                            value: this.statistikData.inquiryArr.refferer.googleAT
                        },
                        {
                            label: "Google CH",
                            value: this.statistikData.inquiryArr.refferer.googleCH
                        },
                        {
                            label: "Yahoo",
                            value: this.statistikData.inquiryArr.refferer.yahoo
                        },
                        {
                            label: "ecosia",
                            value: this.statistikData.inquiryArr.refferer.ecosia
                        },
                        {
                            label: "Keine Angabe",
                            value: this.statistikData.inquiryArr.refferer.emptyString
                        },
                        {
                            label: "Sonstiges",
                            value: this.statistikData.inquiryArr.refferer.sonstiges
                        },
                    ],
                    colors: [
                        "#4285F4",
                        "#008373",
                        "#4267B2",
                        "#F4B400",
                        "#F4B400",
                        "#F4B400",
                        "#F4B400",
                        "#AAAAAA",
                        "#DDDDDD",
                        "#000000"
                    ],
                });

                Morris.Donut({
                    element: 'm_inquiry_project_refferer',
                    data: [
                        {
                            label: "Adwords",
                            value: this.statistikData.doneArr.refferer.adwords
                        },
                        {
                            label: "Bing",
                            value: this.statistikData.doneArr.refferer.bing
                        },
                        {
                            label: "Facebook",
                            value: this.statistikData.doneArr.refferer.facebook
                        },
                        {
                            label: "Google COM",
                            value: this.statistikData.doneArr.refferer.googleCOM
                        },
                        {
                            label: "Google DE",
                            value: this.statistikData.doneArr.refferer.googleDE
                        },
                        {
                            label: "Google AT",
                            value: this.statistikData.doneArr.refferer.googleAT
                        },
                        {
                            label: "Google CH",
                            value: this.statistikData.doneArr.refferer.googleCH
                        },
                        {
                            label: "Yahoo",
                            value: this.statistikData.doneArr.refferer.yahoo
                        },
                        {
                            label: "ecosia",
                            value: this.statistikData.doneArr.refferer.ecosia
                        },
                        {
                            label: "Keine Angabe",
                            value: this.statistikData.doneArr.refferer.emptyString
                        },
                        {
                            label: "Sonstiges",
                            value: this.statistikData.doneArr.refferer.sonstiges
                        },
                    ],
                    colors: [
                        "#4285F4",
                        "#008373",
                        "#4267B2",
                        "#F4B400",
                        "#F4B400",
                        "#F4B400",
                        "#F4B400",
                        "#AAAAAA",
                        "#DDDDDD",
                        "#000000"
                    ],
                });

                Morris.Donut({
                    element: 'm_timetrack_chart',
                    data: [
                        {
                            label: "Franzi",
                            value: this.statistikData.employeeArr[3].hoursUnformat
                        },
                        {
                            label: "Daniela",
                            value: this.statistikData.employeeArr[659].hoursUnformat
                        },
                        {
                            label: "Sarah",
                            value: this.statistikData.employeeArr[341].hoursUnformat
                        },
                        {
                            label: "Steffen",
                            value: this.statistikData.employeeArr[652].hoursUnformat
                        },
                        {
                            label: "Lena",
                            value: this.statistikData.employeeArr[529].hoursUnformat
                        },
                        {
                            label: "Lara",
                            value: this.statistikData.employeeArr[637].hoursUnformat
                        },
                        {
                            label: "Annika",
                            value: this.statistikData.employeeArr[1176].hoursUnformat
                        }
                    ],
                    colors: [
                        "#000000",
                        "#34bfa3",
                        "#666666",
                        "#36a3f7",
                        "#999999",
                        "#716aca"
                    ],
                });
                Morris.Donut({
                    element: 'm_employee_chart',
                    data: [
                        {
                            label: "Franzi",
                            value: this.statistikData.employeeArr[3].sum
                        },
                        {
                            label: "Daniela",
                            value: this.statistikData.employeeArr[659].sum
                        },
                        {
                            label: "Sarah",
                            value: this.statistikData.employeeArr[341].sum
                        },
                        {
                            label: "Steffen",
                            value: this.statistikData.employeeArr[652].sum
                        },
                        {
                            label: "Lena",
                            value: this.statistikData.employeeArr[529].sum
                        },
                        {
                            label: "Lara",
                            value: this.statistikData.employeeArr[637].sum
                        },
                        {
                            label: "Annika",
                            value: this.statistikData.employeeArr[1176].sum
                        }
                    ],
                    colors: [
                        "#000000",
                        "#34bfa3",
                        "#666666",
                        "#36a3f7",
                        "#999999",
                        "#716aca",
                        "#82fe71"
                    ],
                });
                Morris.Donut({
                    element: 'm_category_chart',
                    data: [
                        {
                            label: "Keine Kategorie",
                            value: this.statistikData.doneArr.categoryArr[0].sum
                        },
                        {
                            label: "Freisteller",
                            value: this.statistikData.doneArr.categoryArr[1].sum
                        },
                        {
                            label: "Hollow-Man",
                            value: this.statistikData.doneArr.categoryArr[2].sum
                        },
                        {
                            label: "Legeware",
                            value: this.statistikData.doneArr.categoryArr[3].sum
                        },
                        {
                            label: "Schmuck",
                            value: this.statistikData.doneArr.categoryArr[4].sum
                        },
                        {
                            label: "Schuhe & Socken",
                            value: this.statistikData.doneArr.categoryArr[5].sum
                        },
                        {
                            label: "Unterwäsche",
                            value: this.statistikData.doneArr.categoryArr[6].sum
                        },
                        {
                            label: "Nahrungsergänzungsmittel",
                            value: this.statistikData.doneArr.categoryArr[7].sum
                        },
                        {
                            label: "Schrauben und co.",
                            value: this.statistikData.doneArr.categoryArr[8].sum
                        },
                        {
                            label: "Flaschen & Gläser",
                            value: this.statistikData.doneArr.categoryArr[9].sum
                        },
                        {
                            label: "Kosmetik",
                            value: this.statistikData.doneArr.categoryArr[10].sum
                        },
                        {
                            label: "Haushaltsgeräte",
                            value: this.statistikData.doneArr.categoryArr[11].sum
                        },
                        {
                            label: "Elektrik leicht",
                            value: this.statistikData.doneArr.categoryArr[12].sum
                        },
                        {
                            label: "Elektrik normal",
                            value: this.statistikData.doneArr.categoryArr[13].sum
                        },
                        {
                            label: "Elektrik schwer",
                            value: this.statistikData.doneArr.categoryArr[14].sum
                        },
                        {
                            label: "Portemonnaie",
                            value: this.statistikData.doneArr.categoryArr[15].sum
                        },
                        {
                            label: "Schal, Mützen, Caps, Handschuhe",
                            value: this.statistikData.doneArr.categoryArr[16].sum
                        },
                        {
                            label: "Möbel",
                            value: this.statistikData.doneArr.categoryArr[17].sum
                        },
                        {
                            label: "Teppich, Decken..",
                            value: this.statistikData.doneArr.categoryArr[18].sum
                        },

                    ],
                    colors: [
                        "#000000",
                        "#34bfa3",
                        "#666666",
                        "#36a3f7",
                        "#999999",
                        "#716aca"
                    ],
                });
                Morris.Donut({
                    element: 'm_inquiry_class_chart',
                    data: [
                        {
                            label: "A Kunden",
                            value: this.statistikData.inquiryArr.classArr[1].sum
                        },
                        {
                            label: "B Kunden",
                            value: this.statistikData.inquiryArr.classArr[2].sum
                        },
                        {
                            label: "C Kunden",
                            value: this.statistikData.inquiryArr.classArr[3].sum
                        },
                        {
                            label: "D Kunden",
                            value: this.statistikData.inquiryArr.classArr[4].sum
                        },
                        {
                            label: "E Kunden",
                            value: this.statistikData.inquiryArr.classArr[5].sum
                        },
                        {
                            label: "F Kunden",
                            value: this.statistikData.inquiryArr.classArr[6].sum
                        }
                    ],
                    colors: [
                        "#34bfa3",
                        "#87decd",
                        "#c3efe6",
                        "#777777",
                        "#999999",
                        "#BBBBBB"
                    ],
                });
                Morris.Donut({
                    element: 'm_inquiry_absagen_chart',
                    data: [
                        {
                            label: "Preis zu hoch",
                            value: this.statistikData.inquiryNegativeArr.reasons[1].sum
                        },
                        {
                            label: "Wir bieten den Service nicht an",
                            value: this.statistikData.inquiryNegativeArr.reasons[2].sum
                        },
                        {
                            label: "Anderen Dienstleister gewählt",
                            value: this.statistikData.inquiryNegativeArr.reasons[3].sum
                        },
                        {
                            label: "Keine Rückmeldung",
                            value: this.statistikData.inquiryNegativeArr.reasons[4].sum
                        },
                        {
                            label: "Projekt abgesagt",
                            value: this.statistikData.inquiryNegativeArr.reasons[5].sum
                        },
                        {
                            label: "Arschlochkunde",
                            value: this.statistikData.inquiryNegativeArr.reasons[6].sum
                        },
                        {
                            label: "Sonstiges",
                            value: this.statistikData.inquiryNegativeArr.reasons[7].sum
                        },
                    ],
                    colors: [
                        "#34bfa3",
                        "#87decd",
                        "#c3efe6",
                        "#777777",
                        "#999999",
                        "#BBBBBB",
                        "#000000"
                    ],
                });


            }
        },

        watch: {
            defaultDates: function (val) {
                let them = this;

                $.ajax({
                    url :'/get-evaluation-range',
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: { defaultDates: them.defaultDates },
                    success:  (data) => {
                        data = JSON.parse(data);
                        them.dateFrom = data.dateFrom;
                        them.dateTo = data.dateTo;

                        them.getEvaluationData();
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            }
        },
    }
</script>
